import React, { useEffect, useMemo, useState } from "react";
import { collectionGroup, onSnapshot, orderBy, query } from "firebase/firestore";
import { MdHistory, MdSearch } from "react-icons/md";
import { db } from "../firebase";

const COLORS = {
  primary: "#f20c53",
  secondary: "#fb6c33",
  text: "#0f172a",
  subtext: "#475569",
  border: "#e2e8f0",
  page: "#f5f6f8",
};

export default function ChatSupportAudit() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const qAudit = query(collectionGroup(db, "audit"), orderBy("created_at", "desc"));
    return onSnapshot(qAudit, (snap) => {
      setRows(
        snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ticketId: docSnap.ref.parent.parent?.id || "",
          ...(docSnap.data() || {}),
        }))
      );
    });
  }, []);

  const filteredRows = useMemo(() => {
    const queryText = search.trim().toLowerCase();
    if (!queryText) return rows;
    return rows.filter((row) =>
      [
        row.ticketId,
        row.action,
        row.details,
        row.actor?.name,
        row.actor?.role,
      ].join(" ").toLowerCase().includes(queryText)
    );
  }, [rows, search]);

  return (
    <div style={page}>
      <section style={hero}>
        <div style={heroIcon}><MdHistory /></div>
        <div>
          <h2 style={title}>Chat Audit</h2>
          <p style={sub}>All support assignment, status, priority, and reply actions in one audit page.</p>
        </div>
      </section>

      <section style={card}>
        <div style={searchBox}>
          <MdSearch />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search ticket, action, actor, comment..."
            style={searchInput}
          />
        </div>

        <div style={list}>
          {filteredRows.length === 0 ? (
            <div style={empty}>No audit records found.</div>
          ) : (
            filteredRows.map((row) => (
              <div key={`${row.ticketId}-${row.id}`} style={auditRow}>
                <div style={rowTop}>
                  <strong>{row.action || "updated"}</strong>
                  <span>{formatDate(row.created_at)}</span>
                </div>
                <div style={meta}>
                  Ticket {row.ticketId || "-"} • {row.actor?.name || "Admin"} • {row.actor?.role || "role"}
                </div>
                {row.details ? <div style={details}>{row.details}</div> : null}
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}

function toDate(value) {
  if (!value) return null;
  if (value.seconds) return new Date(value.seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDate(value) {
  const date = toDate(value);
  return date ? date.toLocaleString() : "-";
}

const page = { display: "grid", gap: 14, minHeight: "calc(100vh - 145px)", background: COLORS.page };
const hero = { display: "flex", alignItems: "center", gap: 12, background: "#fff", border: `1px solid ${COLORS.border}`, borderRadius: 14, padding: 16 };
const heroIcon = { width: 46, height: 46, borderRadius: 14, display: "grid", placeItems: "center", color: "#fff", background: `linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary})`, fontSize: 24 };
const title = { margin: 0, color: COLORS.text, fontSize: 24 };
const sub = { margin: "4px 0 0", color: COLORS.subtext, fontSize: 13 };
const card = { background: "#fff", border: `1px solid ${COLORS.border}`, borderRadius: 14, padding: 14, display: "grid", gap: 12 };
const searchBox = { minHeight: 44, display: "flex", alignItems: "center", gap: 8, border: `1px solid ${COLORS.border}`, borderRadius: 12, padding: "0 12px" };
const searchInput = { flex: 1, border: "none", outline: "none", minWidth: 0 };
const list = { display: "grid", gap: 10 };
const auditRow = { border: `1px solid ${COLORS.border}`, borderRadius: 12, background: "#fff", padding: 12 };
const rowTop = { display: "flex", justifyContent: "space-between", gap: 12, color: COLORS.text };
const meta = { marginTop: 5, color: COLORS.subtext, fontSize: 12, fontWeight: 800 };
const details = { marginTop: 8, color: COLORS.text, background: "#f8fafc", borderRadius: 10, padding: 10, fontSize: 13 };
const empty = { color: COLORS.subtext, background: "#f8fafc", border: `1px solid ${COLORS.border}`, padding: 14, borderRadius: 12 };
